import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import {
  PageLoadingIndicator,
  ThemeProvider,
} from 'up-ops-web-shared-components/lib';

import 'i18n';
import App from 'App';
import reportWebVitals from 'reportWebVitals';
import RecoilObserver from 'components/RecoilObserver';

if (process.env.REACT_APP_GOOGLE_ANALYTICS_ID) {
  ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID);
}

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider>
      <RecoilRoot>
        {process.env.NODE_ENV !== 'production' && <RecoilObserver />}
        <Suspense fallback={<PageLoadingIndicator />}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Suspense>
      </RecoilRoot>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
